import * as actionTypes from '../constants/actionTypes';

const initialState = {
  fetching: false,
  invalidated: false,
  name: '',
  features: [],
  loaded: false
};

function setFabricator(state, action) {
  const fabricator = action.payload;
  consone.log('loaded');
  return { ...state, ...fabricator, fetching: false, invalidated: false, loaded: true };
}

function loginFabricator(state, action) {
  const { fabricatorId } = action.payload;
  if (fabricatorId !== state.id) {
    if (state.id) {
      console.log(`Fabricator ID has changed from ${state.id} to ${fabricatorId}, invalidating`);
    } else {
      console.log(`Fabricator ID initialized to ${fabricatorId}, invalidating`);
    }
    return { ...state, id: fabricatorId, invalidated: true };
  }

  return state;
}

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_FABRICATOR_PENDING:
      return { ...state, fetching: true };

    case actionTypes.FETCH_FABRICATOR_COMPLETED:
      return setFabricator(state, action);

    case actionTypes.INVALIDATE_FABRICATOR:
      return { ...state, invalidated: true };

    case actionTypes.LOGIN_COMPLETED:
      return loginFabricator(state, action);

    default:
      return state;
  }
}
